<template>
  <div class="text-xs-center mt-5">
    <v-icon :size="iconSize" v-html="icon" />
    <div class="subheading" v-html="text" />
  </div>
</template>

<script>
  export default {
    props: {
      icon: {
        type: String,
        default: 'search',
      },
      iconSize: {
        type: Number,
        default: 70,
      },
      text: {
        type: String,
        default: 'No results found.',
      },
    },
  }
</script>